<template>
  <div>
  <b-row class="justify-content-center" style="width: 101.1%; height: 50px; overflow: hidden; background: white;">
      <div class="col-md-12">
     <a href="/">
      <img :src="logo" style="width: 190px; padding: 10px 20px;">
    </a>
      </div>
    </b-row>
    <div
      class="app flex-row align-items-center"
      v-bind:style="{
        'background-image': 'url(' + bg_img + ') !important',
        'min-height': '92vh',
        'background-repeat': 'repeat-x !important',
      }"
    >
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="4">
            <b-card-group>
              <b-card no-body class="p-4">
                <b-card-body>
                  <div class="row">
                    <div class="col-md-12" v-if="errorMessage.verifyemail">
                      <div :class="verfiy_color" style="text-align: center">
                        {{ errorMessage.verifyemail }}
                      </div>
                    </div>
                  </div>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <div
                    v-if="hasErrors.message"
                    style="
                      color: red;
                      margin-left: 47px;
                      font-size: 11px;
                      font-weight: bold;" 
                      class="help-block" v-html="errorMessage.message" >
                    <!-- <strong>{{errorMessage.message}}</strong> -->
                  </div>
                  <div
                    v-if="hasErrors.both"
                    style="color: red; margin-left: 47px; font-size: 11px"
                    class="help-block"
                  >
                    <strong>{{ errorMessage.both }}</strong>
                  </div>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="fa fa-phone"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Phone"
                      name="both"
                      id="both"
                      v-model="loginData1.both"
                      required
                    />
                  </b-input-group>
                  <div
                    v-if="hasErrors.password"
                    style="color: red; margin-left: 47px; font-size: 12px"
                    class="help-block"
                  >
                    <strong>{{ errorMessage.password }}</strong>
                  </div>
                  <b-input-group class="mb-3"  v-if="passBox==true">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-lock"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <input
                      type="password"
                      class="form-control"
                      placeholder="Password"
                      v-model="loginData1.password"
                      id="password"
                      name="password"
                    />
                  </b-input-group>
                  <div
                    v-if="hasErrors.otp"
                    style="color: red; margin-left: 47px; font-size: 12px"
                    class="help-block"
                  >
                    <strong>{{ errorMessage.otp }}</strong>
                  </div>
                  <b-input-group class="mb-3"  v-if="otpBox==true">
                    <b-input-group-prepend
                      ><b-input-group-text
                        ><i class="icon-key"></i></b-input-group-text
                    ></b-input-group-prepend>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter OTP"
                      v-model="loginData1.otp"
                      id="otp"
                      name="otp"
                    />
                  </b-input-group>
                  <div
                    v-if="hasErrors.companyname"
                    style="color: red; margin-left: 47px; font-size: 11px"
                    class="help-block"
                  >
                    <strong>{{ errorMessage.companyname }}</strong>
                  </div>
                  
                  <b-input-group class="mb-3">
                    <!-- <div class="form-check form-check-inline mr-1">
                      <input
                        class="form-check-input"
                        id="check1"
                        type="checkbox"
                        v-model="remember"
                      />
                      <label class="form-check-label" for="check1"
                        >Remember</label
                      >
                    </div> -->
                  </b-input-group>
                  <b-row>
                    <b-col cols="6" v-if="passBox==true">
                      <b-button
                        type="button"
                        variant="primary"
                        class="px-4"
                        @click.prevent="loginPost()"
                        >Login</b-button
                      >
                      
                    </b-col>
                    <b-col cols="6" v-if="otpBox==true">
                      <b-button
                        type="button"
                        variant="primary"
                        class="px-4"
                        @click.prevent="loginwithotp()"
                        >Login</b-button
                      >
                      
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button
                        type="button"
                        variant="link"
                        class="px-0"

                        @click.prevent = "Verifythenumber()"
                        >Login With OTP</b-button
                      >
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
              
            </b-card-group>
          </b-col>
        </b-row>
      </div>
      <Spinner v-if="loading"></Spinner>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Spinner from '../../spinner.vue'

export default {
  name: 'CustomerLogin',
  components :{
    Spinner
  },
  computed:{

  },
  data()  {
    return {
      logo:null,
      bg_img:null,
      remember:0,
      loading:false,
      status_color:'alert alert-success',
      warningModal: false,
      warningModal1: false,
      resetemail:'',
      resetpassword:'',
      resettoken:'',
      resetpasswordconf:'',
      checkwarningmodel1:'',
      varificationuser : false,
      verfiy_color:'alert alert-success',
      loginData1:{
        both:'',
        password:'',
        otp:''
      },
      passBox:true,
      otpBox:false,
      customertoken:'',
      customerdata : [],
      Verifiednumber : false,
      NewOTPGenerator: false,
      Continueview:true,
      hasErrors:{
        both:false,
        password:false,
        message:false,
        otp:false
      },
      errorMessage:{
        verifyemail:null,
        both:null,
        password:null,
        message:null,
        statusemail:null
      }
    }
  },
  created(){

    this.logo = this.baseURL2 + '/design/img/logo.png';
    this.bg_img = this.baseURL2 + '/design/img/ban1.jpg';
    var is_remember = this.getCookie('is_remember')
    // var company_id = this.getCookie('company_id')
    var username = this.getCookie('username')

    if(is_remember == 'true'){
      this.remember = true
      this.loginData1.both = username
    }

    this.test();
  },

  methods:{
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    test(){
        // console.log(this.$route.query.id)
      if(this.$route.query.id!=undefined ){
        this.verfiyemai();
      }
      else{
        this.$router.push('/customerlogin');
      }
    },
    
    verfiyemai(){
      var _this=this
      var submit=0
      if(this.$route.query.id!=undefined ){
        if(this.$route.query.id.length<=50){
          this.$router.push('/customerlogin');
          submit=1;
        }
        if(submit==0){
          this.$http.get('/api/users/confirm?uid='+this.$route.query.id+'')
          .then(function (response) {
            _this.verfiy_color="alert alert-success"
            _this.errorMessage.verifyemail="Account Activated Successfully"
              setTimeout(function() { 
                _this.verfiy_color="alert alert-success"
                _this.errorMessage.verifyemail=null
                _this.$router.push('/customerlogin');
              }, 10000);
          })
          .catch(function (error) {
            _this.verfiy_color="alert alert-danger"
            _this.errorMessage.verifyemail="Token Has Been Expired"
            setTimeout(function() {
              _this.verfiy_color="alert alert-success"
              _this.errorMessage.verifyemail=null
              _this.$router.push('/customerlogin');
            }, 10000);
          });
        }
      }
    },
    resetmodel(){
      if(this.checkwarningmodel1!=''){
        if(this.checkwarningmodel1 != 'open1'){
          this.warningModal1=true
        }
      }else{
        this.warningModal = true
      }
    },
    reseturl(){
      var _this=this
      var data ={
        phone:this.resetemail
      }
      this.$http.post('/request-password-reset',data).then(function (response) {
        if(response.status==200){
          // console.log(response)
          _this.warningModal=false
          // _this.checkwarningmodel1='open1'
          // _this.errorMessage.statusemail="Please Check Your Email"
          _this.errorMessage.verifyemail="Please Check Your Email for Password Reset"
          _this.status_color='alert alert-success'
          setTimeout(function() { 
                _this.verfiy_color="alert alert-success"
                _this.errorMessage.verifyemail=null
                // _this.$router.push('/');
              }, 10000);
        }else{
          _this.errorMessage.statusemail="Please Try Again Or Email Id does Not exists"
          _this.status_color='alert alert-danger'
        }
      }).catch(function (error) {
        _this.errorMessage.statusemail=error.response.data.code
        _this.status_color='alert alert-danger'
      });
    },
    
    loginPost1(){
      var _this=this
      if(this.resetpassword===this.resetpasswordconf && this.resettoken!=''){
        var data={newPassword:this.resetpassword,
        confirmation:this.resetpasswordconf}
        // console.log(this.resettoken)
        this.$http.post('/api/users/reset-password?access_token='+this.resettoken,data).then(function (response) {
          _this.errorMessage.statusemail="Password Reset Successfully"
          _this.status_color='alert alert-success'
          _this.checkwarningmodel1=''
        }).catch(function (error) {
          _this.errorMessage.statusemail="Something Went Wrong :("
          _this.status_color='alert alert-danger'
        });
      }
      else if(this.resetpassword!==this.resetpasswordconf){
        _this.errorMessage.statusemail="Password Does Not Match"
        _this.status_color='alert alert-danger'
      }else{
        _this.errorMessage.statusemail="Please Provide Token Id "
        _this.status_color='alert alert-danger'
      }
    },
    
    
    Verifythenumber() {
      var _this = this;
      var vm = this.hasErrors;
      var _vm = this.errorMessage;
      if (this.loginData1.both === "" || this.loginData1.both === null) {
        vm.both = true;
        _vm.both = "Required Phone Number";
      }
      else if(this.loginData1.both.length>10 ||this.loginData1.both.length<10){
         vm.both = true
        _vm.both = "Invalid Phone Number"
        return false;
      }
      else {
        this.loading = true;
        var re =
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var number = /^[0-9]{9,14}$/;

        if (number.test(this.loginData1.both) === true) {
          var log = {
            phone: this.loginData1.both,
          };
        }

        this.$http
          .post("/api/customers/Verifyingphonenumber", log)
          .then(function (response) {
            console.log(response.data);
            console.log("STATUS");
            console.log(log);
            if (response.status === 200) {
              if (response.data.status == 404) {
                vm.both = true;
                _vm.both = "User Not Found";
              } else  if (response.data.status == 200)  {
                _vm.both ='';
      localStorage.setItem(
        "customerphonenumber",
        JSON.stringify(_this.loginData1.both)
      );
                // _this.$router.push("/generateotp");
                _this.otpBox=true,
                _this.passBox=false
                console.log(_this.otpBox)
                alert(response.data.messege)
              }

              _this.loading = false;
            } else if (response.data === 401) {
              vm.both = true;
              _vm.both = "Something went wrong";
              _this.loading = false;
            } else {
              _this.loading = false;
            }
          })
          .catch(function (error) {
            console.log("error");
            console.log(error);
            _this.loading = false;
            vm.message = true;
            _vm.message = error.response.data.error.message;
          });
      }
    },
    loginwithotp(){

var _this = this
var vm = this.hasErrors
var _vm = this.errorMessage
if(this.loginData1.otp==='' || this.loginData1.otp===null ){
  vm.otp = true
  _vm.otp = "OTP Required"
}
else{
  this.loading=true
  
  var log = {
      phonenumber  : this.loginData1.both,
      phoneotp : this.loginData1.otp
  }

  if(this.remember){
    document.cookie = 'is_remember=true';
    document.cookie = 'username='+this.loginData.number 
  }else{ 
    document.cookie = 'is_remember=false';
    document.cookie = 'username='           
  }
  console.log('aaray')
  console.log(log)
  this.$http.post('/api/customers/loginotp', log).then(function (response)
  // this.$http.post('/api/users/customerlogin', log).then(function (response)
   {
     var custtok = null
    // console.log(response.data !=null)
    console.log(response.data.status)
    if(response.data.status == '404'){
        vm.otp = true
        _vm.otp = response.data.messege
        _this.loading=false
        return;
      }
    if(response.data!== null){
     
  var log = {}
      log.phone= response.data[0].cust_cmp_phone,
      log.password=response.data[0].password,
      log.customertoken = custtok
    
      console.log(response.data[0].password)
    
      var log1={
                 phone : response.data[0].cust_cmp_phone,
                 password : response.data[0].password,
                 customertoken: custtok,
              }
              console.log('okkk')
              
                      _this.$store.dispatch("setUserObject", response.data[0].id);
                      localStorage.setItem("authUser", response.data[0].cust_cmp_phone);
                      localStorage.setItem("authUserid",response.data[0].cust_cmp_phone);
                      localStorage.setItem("authCatgeory",'customer');

                      _this.$store.commit("set_is_admin", false);

                      // localStorage.setItem('authUserstatus', status)
                      // _this.$router.push("/customerdashboard");
                     
                      if(response.data[0].password === null || response.data[0].password === ""){
                      console.log("SET Password")
                      _this.$router.push('/setpassword');
                      }else{
                      console.log("No Need to SET Password")
                      _this.$router.push("/customerdashboard");
                      // _this.$router.push("/customerdetails");
                      }
                      _this.loading = false;
    }else if(response.data === null){
         console.log('else loop')
      _this.loading=false
    } 
  })
  .catch(function (error) {

    console.log(error)
    _this.loading=false
    vm.message = true
    _vm.message = error.response.data.error.message
  });
}
},
    GetOTPonPhone(){

      this.$router.props = [this.customerdata.cust_cmp_phone];
      localStorage.setItem("customerphonenumber", JSON.stringify(this.customerdata.cust_cmp_phone));
      this.$router.push("/generateotp");

    },

    loginPost(){

      // this.verficationgeneration();

      // if(this.varificationuser == true){
      if(localStorage.getItem('authUser')!=null){
        this.customertoken = localStorage.getItem('authUser');
      } else{
        console.log('else verification user condition')
        this.customertoken = null;
      }

      var _this = this
      var vm = this.hasErrors
      var _vm = this.errorMessage
      if(this.loginData1.both==='' || this.loginData1.both===null ){
        vm.both = true
        _vm.both = "Required Phone number"
      }
      else if(this.loginData1.both.length>10 ||this.loginData1.both.length<10){
         vm.both = true
        _vm.both = "Invalid Phone Number"
        return false;
      }
      else if(this.loginData1.password==='' || this.loginData1.password===null ){
        vm.password = true
        _vm.password = "Required Password"
      }
      else{
        this.loading=true
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var number=/^[0-9]{9,14}$/;
        
         if(number.test(this.loginData1.both)===true){
          var log = {
            phone: this.loginData1.both,
            password: this.loginData1.password,
            customertoken : this.customertoken
          }
        }
       

        if(this.remember){
          document.cookie = 'is_remember=true';
          document.cookie = 'username='+this.loginData1.both 
        }else{
          document.cookie = 'is_remember=false';
          document.cookie = 'username='           
        }


        this.$http.post('/api/customers/customerlogin', log).then(function (response){
           

         if(response.status=== 200){
           

            console.log(response.data)
            _this.$store.dispatch('setUserObject',response.data.id)
            localStorage.setItem('authUser', response.data.id)
            localStorage.setItem('authUserid', response.data.customer_phone)
            localStorage.setItem('authCustName', response.data.customername)
            localStorage.setItem("authCatgeory",'customer');
           _this.$store.commit('set_is_admin', false)

            // localStorage.setItem('authUserstatus', status)
            _this.$router.push('/customerdashboard');
            // _this.$router.push("/customerdetails");
             _this.loading=false

          }else if(response.status=== 401){
            _this.loading=false
            console.log("401")
            console.log(response)
          } else {
             _this.loading=false
          }
        })
        .catch(function (error) {
          console.log('error')
          console.log(error)
          _this.loading=false
          vm.message = true
          _vm.message = error.response.data.error.message
        });
      }
      // } else {
      //   console.log('else')
      // }
      
    },
    // verficationgeneration(){
    //   console.log('verification generatio')
    //   console.log(!localStorage.getItem('authUser'))
    //   if(localStorage.getItem('authUser')!=null){
    //       this.varificationuser = false;
    //   } else{
    //     console.log('else verification user condition')
    //     this.varificationuser = true;
    //   }

    // }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/goldcustomers/CustomerLogin.vue